import { Link } from "react-router-dom";
import { Leaf } from "lucide-react";

const Footer = () => {
  return (
    <footer className="relative z-10 bg-[#2D3A2D] text-[#F8F6F1]" data-testid="global-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 py-14">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-8">
          {/* Brand */}
          <div className="md:col-span-4">
            <Link to="/" className="inline-flex items-center gap-2.5 mb-4">
              <div className="w-8 h-8 rounded-full bg-[#9FB89F]/30 flex items-center justify-center">
                <Leaf className="w-4 h-4 text-[#9FB89F]" />
              </div>
              <span className="font-serif text-lg font-medium text-white">My Story</span>
            </Link>
            <p className="font-sans text-sm text-white/50 leading-relaxed max-w-xs">
              Your life story, told beautifully. An AI-powered memoir builder that turns conversations into lasting legacies.
            </p>
          </div>

          {/* Quick Links */}
          <div className="md:col-span-3">
            <h4 className="font-sans text-xs uppercase tracking-[0.15em] text-white/40 mb-4">Quick Links</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/login" className="font-sans text-sm text-white/70 hover:text-[#9FB89F] transition-colors" data-testid="footer-link-start">
                  Start Your Story
                </Link>
              </li>
              <li>
                <Link to="/pricing" className="font-sans text-sm text-white/70 hover:text-[#9FB89F] transition-colors" data-testid="footer-link-pricing">
                  Pricing
                </Link>
              </li>
              <li>
                <Link to="/occasions" className="font-sans text-sm text-white/70 hover:text-[#9FB89F] transition-colors" data-testid="footer-link-occasions">
                  Collaborative Books
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div className="md:col-span-3">
            <h4 className="font-sans text-xs uppercase tracking-[0.15em] text-white/40 mb-4">Legal</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/terms" className="font-sans text-sm text-white/70 hover:text-[#9FB89F] transition-colors" data-testid="footer-link-terms">
                  Terms &amp; Conditions
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="font-sans text-sm text-white/70 hover:text-[#9FB89F] transition-colors" data-testid="footer-link-privacy">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/refund" className="font-sans text-sm text-white/70 hover:text-[#9FB89F] transition-colors" data-testid="footer-link-refund">
                  Cancellation &amp; Refund
                </Link>
              </li>
              <li>
                <Link to="/contact" className="font-sans text-sm text-white/70 hover:text-[#9FB89F] transition-colors" data-testid="footer-link-contact">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div className="md:col-span-2">
            <h4 className="font-sans text-xs uppercase tracking-[0.15em] text-white/40 mb-4">Contact</h4>
            <a href="mailto:neginder7@gmail.com" className="font-sans text-sm text-white/70 hover:text-[#9FB89F] transition-colors break-all" data-testid="footer-email">
              neginder7@gmail.com
            </a>
            <p className="font-sans text-xs text-white/40 mt-2 leading-relaxed">
              Mon–Fri, 9 AM – 6 PM IST
            </p>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="font-sans text-xs text-white/30" data-testid="footer-copyright">
            &copy; {new Date().getFullYear()} my-story.in — All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <Link to="/terms" className="font-sans text-xs text-white/30 hover:text-white/60 transition-colors">Terms</Link>
            <Link to="/privacy" className="font-sans text-xs text-white/30 hover:text-white/60 transition-colors">Privacy</Link>
            <Link to="/refund" className="font-sans text-xs text-white/30 hover:text-white/60 transition-colors">Refund</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
